import { render } from "./AgentLinkHelp.vue?vue&type=template&id=4f988b0a&scoped=true"
const script = {}

import "./AgentLinkHelp.vue?vue&type=style&index=0&id=4f988b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f988b0a"]])

export default __exports__